<template>
  <tk-container class="user">
    <tkui-header slot="header">
      <tk-icon @click.native="back">Return</tk-icon>
    </tkui-header>
    <div class="bg">
      <div class="bight"></div>
    </div>
    <div class="avatarBox" @click="toUser2">
      <div class="avatar" v-if="!user.avatar"></div>
      <tk-image :src="user.avatar" width="75" height="75" style="border-radius: 50%" v-else></tk-image>
      <p class="tel" v-if="user.phone">{{user.phone}}</p>
    </div>
    <p class="item" style="margin-top: 70px;" @click="feedback">
      <tk-icon style="color:#FC7B53;">Feedback</tk-icon>&nbsp;&nbsp;<span>意见反馈</span>
    </p>
    <p class="item" @click="about">
      <tk-icon style="color:#0091FF;">About</tk-icon>&nbsp;&nbsp;<span>关于我们</span>
    </p>
    <div class="btnBox">
      <tkui-button @click.native="quit" class="block raised primary rounded">退出登录</tkui-button>
    </div>
  </tk-container>
</template>

<script>
  export default {
    data () {
      return {}
    },
    computed: {
      user () {
        return this.$store.state.user || {}
      }
    },
    methods: {
      back () {
        this.$back()
      },
      toUser2 () {
        this.$push('/user2')
      },
      feedback () {
        this.$push('/feedback')
      },
      about () {
        this.$push('/about')
      },
      quit () {
        this.$store.commit('setUser', null)
        this.$store.commit('setSessionToken', null)
        this.$tkAjaxGlobal.headers['X-Parse-Session-Token'] = ''
        this.$cleanHistory()
        this.$replace('/login')
      }
    }
  }
</script>

<style scoped lang="scss" rel="stylesheet/scss">
  .user{
    background: #ffffff;
    position: relative;
    .bg{
      width: 100%;
      height: 100px;
      background: #0091ff;
      padding-top: 45px;
      .bight{
        width: 100%;
        height: 120px;
        background: #ffffff;
        border-radius: 50%;
        position: relative;
        z-index: 10;
      }
    }
    .avatarBox{
      position: absolute;
      left: 60px;
      top: 20px;
      padding-top: 10px;
      z-index: 10;
      .avatar{
        width: 75px;
        height: 75px;
        border-radius: 50%;
        background: #DAF1FF;
      }
      .tel{
        font-size: 16px;
        color: #333333;
        font-weight: 700;
        margin-top: 10px;
      }
    }
    .item{
      margin-top: 30px;
      margin-left: 60px;
      color: #233038;
      font-size: 16px;
      font-weight: 700;
    }
    .btnBox{
      padding: 0 15px;
      margin-top: 150px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/page/app/user/user.vue